export const REQUIREMENT_SOURCE_OPTIONS = [
  'TL Created',
  'Client Assigned',
  'Admin Created',
  'Assigned',
];

export function getRequirementCreatorId(row = {}) {
  const requirement = row.requirementDetails || row.requirement || row;
  return String(requirement.createdBy || requirement.uploadedBy || '').trim();
}

const GENERIC_SOURCE_LABELS = new Set([
  'TL Created',
  'Client Assigned',
  'Admin Created',
  'Assigned',
]);

export function getRequirementSourceFromRow(row = {}) {
  const requirement = row.requirementDetails || row.requirement || row;
  const creatorName = row.creatorName || requirement?.creatorName;
  if (creatorName && creatorName !== '—') return creatorName;

  const source = row.requirementSource
    || requirement?.requirementSource;
  if (source && !GENERIC_SOURCE_LABELS.has(source)) return source;

  return creatorName || '—';
}

export function getRequirementSourceBadgeClass(_source = '', row = {}) {
  const userType = row.creatorUserType
    || row.requirementDetails?.creatorUserType
    || row.requirement?.creatorUserType
    || '';

  switch (userType) {
    case 'TeamLead':
      return 'bg-success';
    case 'Admin':
      return 'bg-warning text-dark';
    case 'User':
      return 'bg-info text-dark';
    default:
      return 'bg-secondary';
  }
}

export function isRequirementCreatedByUser(row = {}, userId = '') {
  if (!userId) return false;
  return getRequirementCreatorId(row) === String(userId);
}
